import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { GitBranch } from 'lucide-react';
import useObjectDefinitions from '../../hooks/useObjectDefinitions';

function FastestFormCRMLayout() {
  const location = useLocation();
  const { objectDefinitions } = useObjectDefinitions();

  const tabs = [
    ...objectDefinitions.map((od) => ({
      path: `/data/${od.slug_plural || od.slug}`,
      label: od.name.endsWith('s') ? od.name : `${od.name}s`,
    })),
    { path: '/data/pipelines', label: 'Pipelines', icon: GitBranch },
  ];

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="mt-5 mb-6">
        <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100">CRM</h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Manage your companies and contacts
        </p>
      </div>

      {/* Tab Navigation */}
      <div className="flex space-x-1 bg-gray-100 dark:bg-gray-800 rounded-lg p-1 w-fit mb-6">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = location.pathname === tab.path || location.pathname.startsWith(tab.path + '/');
          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={`flex items-center px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-white dark:bg-gray-700 text-brand-600 dark:text-brand-400 shadow-sm'
                  : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
              }`}
            >
              {Icon && <Icon className="w-4 h-4 mr-2" />}
              {tab.label}
            </Link>
          );
        })}
      </div>

      <Outlet />
    </div>
  );
}

export default FastestFormCRMLayout;
